<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"
  import { type TransitionConfig } from "svelte/transition"
  import { stroke } from "./animation"

  let {
    closure = 0,
    success = false,
    transition = () => ({}),
    ...props
  }: {
    /** The frame closure percentage in [0, 1] range */
    closure?: number
    /** Pass `true` to render the Frame in the "success" color */
    success?: boolean
    transition?: (node: Element) => TransitionConfig
    [key: string]: any
  } & HTMLAttributes<SVGElement> = $props()

  const initialValue = closure

  let isStrokeTransitionEnabled = $state(false)
  let value = $derived(Math.max(0, Math.min(closure, 1)))

  $effect(() => {
    if (value !== initialValue) isStrokeTransitionEnabled = true
  })
</script>

<svg
  {...props}
  class={[
    "camera-frame", // Anchor for external customization
    "text-white",
    props.class,
  ]}
  viewBox="0 0 240 317"
  transition:transition
>
  <rect
    x="8"
    y="8"
    width="224"
    height="301"
    rx="40"
    fill="none"
    stroke-width="3"
    stroke-linecap="round"
    stroke-dasharray="100.832, 173, 110.832, 96"
    vector-effect="non-scaling-stroke"
    class={[
      "drop-shadow-[0px_0px_1px_rgba(0,0,0,0.4)]",
      success ? "stroke-[#B5FF6A]" : "stroke-current",
      { "transition-[stroke-dasharray,stroke-dashoffset]": isStrokeTransitionEnabled },
    ]}
    use:stroke={value}
  />
</svg>
